import React, { useState, useEffect } from 'react';
import { useStyle } from './PrequalStyle.js';
import Card from '@material-ui/core/Card';
import { CardContent } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { BrowserRouter } from 'react-router-dom';

import CloseIcon from '@material-ui/icons/Close';
import { primaryText } from '../../utils/CssGlobalVariables';

export default function EirFixedCardFooter(props) {
    const classes = useStyle({
        themeColor: props.themeColor,
        themeColorOnHover: props.themeColorOnHover,
        themeColorForBroadbandCards: props.themeColorForBroadbandCards,
        themeColorForBroadbandCardsHover: props.themeColorForBroadbandCardsHover,
        useBroadbandCardColor: props.useBroadbandCardColor,
    });
    const [expand, setExpand] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openAnnualPopUp, setOpenAnnualPopUp] = useState(false);
    const [popUpMessage, setPopUpmessage] = useState('');

    //To collapse more info section on prequal or on clearing prequal
    useEffect(() => {
        setExpand(false);
    }, [props.bundleData]);

    let feeType = props.standardFees.filter(fee => {
        return fee.feeAmount > 0;
    });
    const activePromos = props.prices.filter(promo => {
        return promo.activePromos !== null && promo.activePromos.length > 0;
    });
    const moreInfo = props.moreInfo.filter(info => {
        return (
            (!info.value.includes('{fees}') || feeType.length > 0) &&
            (!info.value.includes('{promoprice}') || activePromos.length > 0)
        );
    });
    const handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
        setExpand(!expand);
    };
    const handleOpen = setUpFeeArray => {
        let message;
        setUpFeeArray.forEach(fee => {
            switch (fee.feeType) {
                case 'ACTIVATION':
                    if (message) {
                        message = message + ' and the activation fee is ' + `€${fee.feeAmount}`;
                    } else {
                        message = 'The activation fee is ' + `€${fee.feeAmount}`;
                    }
                    break;
                case 'INSTALLATION':
                    if (message) {
                        message = message + ' and the installation fee is ' + `€${fee.feeAmount}`;
                    } else {
                        message = 'The installation fee is ' + `€${fee.feeAmount}`;
                    }
                    break;
            }
        });
        setPopUpmessage(message);
        setOpenDialog(true);
    };

    const handleAnnualOpen = message => {
        setPopUpmessage(message);
        setOpenAnnualPopUp(true);
    };
    const handleClose = () => {
        setPopUpmessage('');
        setOpenDialog(false);
        setOpenAnnualPopUp(false);
    };
    const renderContent = content => {
        return { __html: content };
    };
    return (
        <div>
            <BrowserRouter>
                <Card className={classes.ContentRoot}>
                    <CardContent
                        className={!props.buttonState ? classes.Content : classes.ContentHover}
                        onClick={e => handleClick(e)}>
                        <Typography>More info</Typography>
                        <ExpandMoreIcon
                            className={expand && classes.PrequalBundleCardFooterArrow}
                        />
                    </CardContent>
                    {expand && (
                        <CardContent
                            className={
                                classes.PrequalBundleCardFooter +
                                ' ' +
                                (props.buttonState ? classes.PrequalBundleCardFooterHover : '')
                            }>
                            <ul>
                                {moreInfo.map((info, index) => (
                                    <li key={index}>
                                        {info.value.includes('{promoprice}') && (
                                            <Typography
                                                dangerouslySetInnerHTML={renderContent(
                                                    info.value
                                                        .replace(
                                                            '{promoprice}',
                                                            `€${
                                                                props.prices[props.priceIndex]
                                                                    .priceFormatted
                                                            }`
                                                        )
                                                        .replace(
                                                            '{contract}',
                                                            props.prices[props.priceIndex].months +
                                                                props.prices[props.priceIndex]
                                                                    .startMonth
                                                        )
                                                        .replace(
                                                            '{afterprice}',
                                                            `€${
                                                                props.prices[props.priceIndex + 1]
                                                                    .priceFormatted
                                                            }`
                                                        )
                                                )}></Typography>
                                        )}
                                        {info.value.includes('{fees}') && (
                                            <Tooltip
                                                classes={{ tooltip: classes.customTooltipFee }}
                                                interactive={true}
                                                title={
                                                    <span>
                                                        <div style={{ display: 'flex' }}>
                                                            <CloseIcon
                                                                style={{
                                                                    marginLeft: 'auto',
                                                                    color: primaryText,
                                                                }}
                                                                fontSize='small'
                                                                onClick={() => handleClose()}
                                                            />
                                                        </div>
                                                        <Typography
                                                            className={classes.customTooltipText}
                                                            dangerouslySetInnerHTML={renderContent(
                                                                popUpMessage
                                                            )}></Typography>
                                                    </span>
                                                }
                                                open={openDialog}
                                                arrow>
                                                {feeType.length >= 1 && (
                                                    <Typography
                                                        onClick={() => {
                                                            {
                                                                openDialog
                                                                    ? handleClose()
                                                                    : handleOpen(feeType);
                                                            }
                                                        }}
                                                        dangerouslySetInnerHTML={renderContent(
                                                            info.value.replace('{fees}', '')
                                                        )}></Typography>
                                                )}
                                            </Tooltip>
                                        )}
                                        {props.moreInfoPopupMsg.map(msg =>
                                            msg.parentId === info.id ? (
                                                <Tooltip
                                                    classes={{ tooltip: classes.customTooltip }}
                                                    interactive={true}
                                                    title={
                                                        <span>
                                                            <div style={{ display: 'flex' }}>
                                                                <CloseIcon
                                                                    className={classes.closeIcon}
                                                                    fontSize='small'
                                                                    onClick={() => handleClose()}
                                                                />
                                                            </div>
                                                            <Typography
                                                                className={
                                                                    classes.customTooltipText
                                                                }
                                                                dangerouslySetInnerHTML={renderContent(
                                                                    popUpMessage
                                                                )}></Typography>
                                                        </span>
                                                    }
                                                    open={openAnnualPopUp}
                                                    arrow>
                                                    <Typography
                                                        key={index}
                                                        onClick={() => {
                                                            {
                                                                !msg.value
                                                                    ? handleClose()
                                                                    : handleAnnualOpen(msg.value);
                                                            }
                                                        }}
                                                        dangerouslySetInnerHTML={renderContent(
                                                            info.value
                                                        )}></Typography>
                                                </Tooltip>
                                            ) : (
                                                !(
                                                    info.value.includes('{promoprice}') ||
                                                    info.value.includes('{fees}')
                                                ) && (
                                                    <Typography
                                                        dangerouslySetInnerHTML={renderContent(
                                                            info.value
                                                        )}></Typography>
                                                )
                                            )
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </CardContent>
                    )}
                    {/* {openDialog && <PrequalDialougeBox message={popUpMessage} />} */}
                </Card>
            </BrowserRouter>
        </div>
    );
}
